/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DatahubLoaderParamsBasic } from '../models/DatahubLoaderParamsBasic';
import type { DatahubLoaderParamsModuleJob } from '../models/DatahubLoaderParamsModuleJob';
import type { DataLoader } from '../models/DataLoader';
import type { DataLoaderParams } from '../models/DataLoaderParams';
import type { DataLoaderSort } from '../models/DataLoaderSort';
import type { DataLoaderType } from '../models/DataLoaderType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DataLoaderService {

    /**
     * get the url of the latest dh dataloader report
     * @returns any Success
     * @throws ApiError
     */
    public static getReportUrl({
        requestBody,
    }: {
        requestBody: {
            dataLoaderId?: string;
        },
    }): CancelablePromise<{
        url?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/getReportUrl',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Load a survey job rollup file
     * @returns any Success
     * @throws ApiError
     */
    public static addFileSurveyJobRollup({
        requestBody,
    }: {
        requestBody: DatahubLoaderParamsModuleJob,
    }): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/surveyJobRollup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Load a survey tenant file
     * @returns any Success
     * @throws ApiError
     */
    public static addFileSurveyTenant({
        requestBody,
    }: {
        requestBody: DatahubLoaderParamsBasic,
    }): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/surveyTenant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of files
     * @returns DataLoader Success
     * @throws ApiError
     */
    public static getFiles({
        type,
        limit,
        offset,
        sort,
    }: {
        /**
         * Data Loader Type
         */
        type: DataLoaderType,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Sorting options
         */
        sort?: DataLoaderSort,
    }): CancelablePromise<Array<DataLoader>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataLoader',
            query: {
                'limit': limit,
                'offset': offset,
                'sort': sort,
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Load a file
     * @returns any Success
     * @throws ApiError
     */
    public static loadDataLoaderFile({
        type,
    }: {
        /**
         * Data Loader Type
         */
        type: DataLoaderType,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataLoader',
            query: {
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * download Data Loader file
     * @returns any Success
     * @throws ApiError
     */
    public static downloadFile({
        id,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataLoader/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * delete Data Loader file
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataLoader({
        id,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dataLoader/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Edit data loader
     * @returns DataLoader Success
     * @throws ApiError
     */
    public static editDataLoader({
        id,
        requestBody,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
        requestBody: {
            name?: string;
            effectiveDate?: string;
        },
    }): CancelablePromise<DataLoader> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataLoader/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * rerun process
     * @returns any Success
     * @throws ApiError
     */
    public static rerunLoad({
        id,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
    }): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataLoader/{id}/rerun',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * download Data Loader Error file
     * @returns any Success
     * @throws ApiError
     */
    public static downloadErrorFile({
        id,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataLoader/{id}/error',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Process a data loader
     * @returns any Success
     * @throws ApiError
     */
    public static processDataLoader({
        requestBody,
    }: {
        requestBody: DataLoaderParams,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataLoader/process',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get last user data loader
     * @returns any Success
     * @throws ApiError
     */
    public static getLastUserDataLoader({
        type,
    }: {
        /**
         * Data Loader Type
         */
        type: DataLoaderType,
    }): CancelablePromise<{
        lastDataLoader: (DataLoader | Record<string, any> | null);
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataLoader/last/{type}',
            path: {
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * upload file
     * @returns any Success
     * @throws ApiError
     */
    public static uploadDataLoaderFile({
        type,
        formData,
    }: {
        /**
         * File Type
         */
        type: string,
        formData: {
            file?: Blob;
        },
    }): CancelablePromise<{
        bucket?: string | null;
        key?: string | null;
        name?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataLoader/upload/{type}',
            path: {
                'type': type,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
